var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.5 160.4",
    style: {
      enableBackground: "new 0 0 141.5 160.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B5CD30;}\n\t.st1{fill:#191F29;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,160.3c-2.7-1.4-3.4-3.6-3.4-6.5c0.1-19.7,0-39.3,0-59c0-0.6,0-1.2,0-2.1c-0.8,0.4-1.4,0.7-1.9,1.1 c-14,8.1-28.1,16.2-42.1,24.3c-2.4,1.4-5,2.3-7.9,1.9c-4.1-0.6-7-2.9-8.6-6.6c-1.7-3.9-1.1-7.6,1.5-11c0.4-0.6,1-1.1,1.5-1.6 c8.2-7.6,16.3-15.2,24.5-22.8c4.9-4.6,10.7-7,17.4-7c4.4,0,8.5,1,12.4,3.2c-2.3,8.2-0.4,15.2,6.9,19.8c7.4,4.6,14.5,3.2,21-2.6 c0,0.8,0,1.3,0,1.9c0,20.3,0,40.7,0,61c0,2.9-0.8,4.9-3.5,6.1C76.7,160.3,70.8,160.3,64.8,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,69.3c-4.8-5.2-10.6-7-17.5-5.3c0-0.7-0.1-1.1-0.1-1.6c0-16.9,0-33.8,0-50.7c0-4.8,1.8-8.7,6.4-10.7 c6.6-3,13.7,0.6,15.3,7.8C93.4,20,96,31.1,98.5,42.3c2.3,10.3-2.2,21-11,26.6C87.2,69,86.9,69.1,86.6,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.6,87.1c0.7,0.3,1.1,0.5,1.5,0.8c12.7,7.3,25.4,14.7,38.1,22c3,1.7,5.3,4.1,6,7.6c1.7,8-5.5,15.1-13.4,12.9 c-10-2.8-19.9-6-29.8-9c-2.4-0.7-2.4-0.7-2.4-3.3c0-9.6,0-19.3,0-28.9C95.6,88.5,95.6,87.9,95.6,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,87.1c-4,0-7.1-3.2-7.1-7.2c0-3.9,3.3-7.2,7.2-7.1c3.9,0.1,7.2,3.4,7.1,7.2C81,84,77.8,87.1,73.8,87.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.67ea47c827665550e4f6d736f79ca0ae.svg";
export { ForwardRef as ReactComponent };